import { ThemeConfig } from '@one/models/theme.model';
import { BRAND_CONFETTI_COLORS } from '@one/utils/confetti.utils';

/** Tons do acento lidos na hora do disparo. No claro: a escala do primary. */
const LIGHT_TOKENS: string[] = ['--agj-color-primary', '--agj-color-primary-dark', '--agj-color-primary-light', '--agj-color-primary-lightest', '--agj-color-primary-lighter'];
/** No escuro a escala legada é invertida (lighter/lightest viram tintas escuras): só os tons claros do acento. */
const DARK_TOKENS: string[] = ['--agj-color-primary', '--agj-color-primary-hover', '--agj-color-primary-active', '--agj-color-primary-darkest', '--agj-color-on-primary-container'];

/** Confete da confirmação na cor da empresa (Anexo K.6). Roxo claro = a paleta de hoje (paridade). */
export function themeConfettiColors(theme: ThemeConfig, doc: Document): string[] {
  if (theme.mode === 'light' && theme.accent === 'purple') return BRAND_CONFETTI_COLORS;

  const style: CSSStyleDeclaration | undefined = doc.defaultView?.getComputedStyle(doc.documentElement);
  const colors: string[] = (theme.mode === 'dark' ? DARK_TOKENS : LIGHT_TOKENS).map((name: string) => style?.getPropertyValue(name).trim() || '').filter(Boolean);

  return colors.length ? colors : BRAND_CONFETTI_COLORS;
}
